import { Card, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { Booth } from '../../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../../reduxToolkit/typedRedux';
import { getBoothVCardsDownloads } from '../../../../../../../../services/services';

export interface BoothVCardDownloads {
  downloads: number;
  vcard: {
    adresse: {
      address: string;
      city: string;
      postalcode: string;
      street: string;
    };
    datetime_created: Date;
    email: string;
    firstname: string;
    lastname: string;
    meetingroom: string;
    middlename: string;
    note: string;
    organization: string;
    phone: string;
    prefix: string;
    role: string;
    _id: string;
  };
}

export const BoothVCardDownloads = ({ booth }: { booth: Booth }) => {
  const [boothVCardDownloads, setBoothVCardDownloads] = useState<BoothVCardDownloads[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const event = useSelector((state) => state.admin.event);
  const { t } = useTranslation();
  useEffect(() => {
    fetchData();
  }, [booth]);

  async function fetchData() {
    setIsLoading(true);
    try {
      const boothVCardDownloads = await getBoothVCardsDownloads(booth._id);
      setBoothVCardDownloads(boothVCardDownloads);
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  }
  return (
    <>
      {(boothVCardDownloads.length !== 0 && event?.template?.uiTemplate === 'vystem-zukunftsrat') ||
        (event?.template?.uiTemplate === 'vbw-additive-manufacturing' && (
          <div className=" mt-8 w-auto">
            {isLoading ? (
              <Card className="w-full" elevation={3}>
                <div className="text-center m-4">
                  <Skeleton animation="wave" height={30} width="100%" style={{ marginBottom: 6 }} />
                  <Skeleton animation="wave" height={30} width="100%" style={{ marginBottom: 6 }} />
                  <Skeleton animation="wave" height={30} width="100%" style={{ marginBottom: 6 }} />
                </div>
              </Card>
            ) : (
              <TableContainer elevation={3} component={Paper}>
                <div className="ml-2 mt-4 mb-2 pl-4">
                  <Typography className="font-size: 1rem;line-height: 1.5rem; capitalize" color="textSecondary" gutterBottom>
                    {t('stats:vcard-downloads-track')}
                  </Typography>
                </div>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{t('stats:vcard-firstname')}</TableCell>
                      <TableCell align="right">{t('stats:vcard-downloads')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {boothVCardDownloads.map((data, i) => (
                      <TableRow key={data.vcard._id}>
                        <TableCell align="left">{data.vcard?.firstname.trim() !== '' ? data.vcard.firstname : 'VCard ' + i}</TableCell>
                        <TableCell align="right">{data.downloads}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        ))}
    </>
  );
};
